import React, { Component } from "react";
import { Col } from 'react-bootstrap';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import TextArea from "react-validation/build/textarea";
import Select from "react-validation/build/select";
import CheckButton from "react-validation/build/button";
import { withRouter} from 'react-router-dom';
import mixin from "../../../utils/mixin";
import consts from "../../../utils/constants";

import './LotForm.scss';

import { addLot, updateLot, deleteLot } from '../../../api/Api.js';
import { isEmpty, method } from "lodash";

const { methods } = mixin;

const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Campo requerido
      </div>
    );
  }
};

const positiveNumber = value => {
  if (!isNaN(value) && value < 0) {
    return (
      <div className="alert alert-danger" role="alert">
        Ingresa un número válido.
      </div>
    );
  }
};

const def_lot  = {
  _id: null,
  name: null,
  development_id: null,
  status: '',
  height: 3,
  metadata: [],
  coordinates: [],
  block: null,
  number: null,
  price: 0,
  discount: 0,
  deleted: 0,
  tower_id: null,
  story_number: null,
  story_id: null,
  sepparator_id: null,
}

class LotForm extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      message: null,
      loading: false,
      loading_lot: false,
      invalid_coords: false,
      lot: {
        _id: null,
        name: null,
        development_id: null,
        status: '',
        height: 3,
        metadata: [],
        coordinates: [],
        block: null,
        number: null,
        price: 0,
        discount: 0,
        deleted: 0,
        tower_id: null,
        story_number: null,
        story_id: null,
        sepparator_id: null
      },
      coords: [],
      coords_qty: 4,
      lot_metadata: {},
      metadata: [
        'FASE',
        'AREA',
        'AREA_HA',
        'PERIMETER',
        'FRONT',
        'DEPTH',
        'PRICE_M2',
        'LOT_PRICE',
        'PROMO',
        'FEATURES',
        'NOTES',
      ],
      prev_lot_id: null,
    };
  }

  isLotEditable = () => {
    return ( 
      this.props.action == 'update' && methods.G_canDo(consts.Security.Action.UPDATE_LOT, localStorage.getItem('user')) ||
      this.props.action == 'add' && methods.G_canDo(consts.Security.Action.CREATE_LOT, localStorage.getItem('user'))
    );
  }

  validateCoords = () => {
    if(this.state.coords.length > 0){
      for(let i = 0; i < this.state.coords.length; i++){
        if(this.state.coords[i] == null || this.state.coords[i] == undefined || 
            this.state.coords[i].length != 2){
          this.setState({
            invalid_coords: true
          });
          return false;
        }
      }
      
      return true
    }
    return false;
  }
  
  handleSubmit = (e) => {
    //const{ username, password}  = this.state;
    e.preventDefault();

    this.setState({
      message: "",
      loading: true
    });

    this.form.validateAll();
    let validCoords = this.validateCoords();
    if (this.checkBtn.context._errors.length === 0 && validCoords) {
      
      let data = {...this.state.lot};
      let meta = [];
      let lot_id = data._id;
      delete data['_id'];
      delete data['tower'];
      data.coordinates = this.state.coords;
      data.deleted = 0;
      
      
      for (const [key, value] of Object.entries(this.state.lot_metadata)) {
        let item = {}
        item[key] = value;
        meta.push(item);
      }
      data.metadata = meta;
      data.development_id = this.props.development_id;
      

      if(this.props.action == 'update'){
        updateLot({lot_id, data}).then(
          (res) => {
            if(res && res['_id']){
              this.props.update(res);
              this.props.close();
            }else{
              this.setState({
                loading: false,
                message: 'No se pudo actualizar el lote. Intenta nuevamente.'
              });
            }
          }
        );
      }else{
        addLot(data).then(
          (res) => {
            if(res && res['_id']){
              this.props.add(res);
              this.props.close();
            }else{
              this.setState({
                loading: false,
                message: 'No se pudo agregar el lote. Intenta nuevamente.'
              });
            }
          }
        );
      }

    } else {
      this.setState({
        loading: false
      });
    }
  }

  renderTitle(){
    if(this.props.action == 'update' && this.props.lot){
      return '';
    }
    return (<div>
              <h3>Agregar Lote</h3>
              <br/>
            </div>);
  }

  static getDerivedStateFromProps = (props, state) => {
    let l = def_lot;
    let coords = [];
    let coords_qty = 4;
    let meta = {}
    if(props.lot_id !== state.prev_lot_id){
      
      if(props.lot){
        l = {...props.lot}
      }
      
      if(props.lot && props.lot.coordinates){
        if(props.utm && props.lot.coordinates.utm){
          coords = [...props.lot.coordinates.utm];
          coords_qty = props.lot.coordinates.utm.length;
        }else{
          coords = [...props.lot.coordinates.latlon];
          coords_qty = props.lot.coordinates.latlon.length;
        }
      }else{
        for (let i = 0; i < coords_qty; i++){
          coords.push([]);
        }
      }

      if(props.lot && props.lot.metadata){
        for(let i = 0; i < props.lot.metadata.length; i++){
          for (const [key, value] of Object.entries(props.lot.metadata[i])) {
            meta[key] = value;
          }
        }
      }

      return{
        prev_lot_id: props.lot_id,
        lot: l,
        coords: coords,
        coords_qty: coords_qty,
        lot_metadata: meta,
      }
    }
    return null;
  }

  addCoordRow = () => {
    let coords = this.state.coords;
    coords.push([]);
    this.setState({
      coords: coords,
      coords_qty: this.state.coords_qty + 1,
      invalid_coords: false
    });
  }

  delCoordRow = () => {
    let coords = this.state.coords;
    coords.pop();
    this.setState({
      coords: coords,
      coords_qty: this.state.coords_qty - 1,
      invalid_coords: false
    });
  }

  renderAddCoordBtn = (i) => {
    if(i + 1 == this.state.coords_qty && this.isLotEditable()){
      if(i >= 3){
        return (
          <Col xs="3">
            <button className="btn btn-success btn-sm btn-round mr-3" onClick={this.addCoordRow}>+</button>
            <button className="btn btn-danger btn-sm btn-round" onClick={this.delCoordRow}>-</button>
          </Col>
        )
      }
      return (
        <Col xs="3">
          <button className="btn btn-success btn-sm btn-round" onClick={this.addCoordRow}>+</button>
        </Col>
      )
    }
  }

  renderCoordinatesInputs = () => {
    const listCoords = this.state.coords.map((i, index) => { 
        return (
          <div key={'point_' + index} className="form-group row">
            <label className="col-1 text-right" htmlFor="username">P{index + 1}</label>
            <Col xs="4">
              <Input
                type="number"
                className="form-control"
                name={'coordintates[' + index + ']'}
                value={i[0]}
                onChange={this.onChangeCoord.bind(this, index, 0)}
                validations={[]}
                disabled={!this.isLotEditable()}
              />
            </Col>
            <Col xs="4">
              <Input
                type="number"
                className="form-control"
                name={'coordintates[' + index + ']'}
                value={i[1]}
                onChange={this.onChangeCoord.bind(this, index, 1)}
                validations={[]}
                disabled={!this.isLotEditable()}
              />
            </Col>
            {this.renderAddCoordBtn(index)}
          </div>
        )
      
    });

    return (
      <div>
        {listCoords}
        {
          this.state.invalid_coords &&
          <div className="alert alert-danger" role="alert">
            Ingresa todas las coordenadas del lote.
          </div>
        }
      </div>
    );
  }

  renderCoordinateTitle = (i) => {
    if (i == 0){
      return this.props.utm ? 'Este' : 'Latitud';
    }
    return this.props.utm ? 'Norte' : 'Longitud';
  }

  renderCoordsTypeTitle = () => {
    return !this.props.utm ? 'UTM' : 'Lat / Long';
  }

  getSaveBtnLabel = () => {
    return this.props.action == 'add' ? 'Agregar' : 'Guardar';
  }

  renderMetadataInputs(){
    const listMetadata = this.state.metadata.map((k) => {
      let label = '';
      let type = 'text';
      let required_field = false;
      let disabled_field = false;

      switch(k){
        case 'AREA': label = 'Área (m2)'; type = 'number'; required_field = false; break;
        case 'AREA_HA': label = 'Área (ha)'; type = 'number'; required_field = false; break;
        case 'PERIMETER': label = 'Perímetro (m)'; type = 'number'; required_field = false; break;
        case 'FRONT': label = 'Frente (m)'; type = 'number'; required_field = false; break;
        case 'DEPTH': label = 'Fondo (m)'; type = 'number'; required_field = false; break;
        case 'FASE': label = 'Fase'; type = 'text'; required_field = false; break;
        case 'FEATURES': label = 'Características'; type = 'textarea'; required_field = false; break;
        case 'NOTES': label = 'Notas'; type = 'textarea'; required_field = false; break;
        case 'PRICE_M2': label = 'Precio m2 (MXN)'; type = 'number'; required_field = false; break;
        case 'LOT_PRICE': label = 'Precio Lote (MXN)'; type = 'number'; required_field = false; disabled_field = true; break;
        case 'PROMO': label = 'Promoción'; type = 'textarea'; required_field = false; break;
        default: label = k; type = 'text'; required_field = false; break;
      }

      let check = [];
      if(required_field){
        check.push(required);
      }
      if(type == 'number'){
        check.push(positiveNumber);
      }

      if(type == 'textarea'){
        return (
          <Col key={k} sm="6">
            <div className="form-group">
              <label htmlFor={k}>{label}</label>
              <TextArea
                className="form-control"
                name={k}
                value={this.state.lot_metadata[k] ? this.state.lot_metadata[k] : ''}
                onChange={this.onChangeMetadata.bind(this, k)}
                validations={check}
                disabled={!this.isLotEditable() || disabled_field}
              />
            </div>
          </Col>
        )
      }

      let field_value = this.state.lot_metadata[k];
      if(k == 'LOT_PRICE'){
        if(this.state.lot_metadata['PRICE_M2'] && this.state.lot_metadata['AREA']){
          field_value = parseFloat(this.state.lot_metadata['PRICE_M2']) * parseFloat(this.state.lot_metadata['AREA']);
          field_value = field_value.toFixed(2);
        }else{
          field_value = '';
        }
      }

      return (
        <Col key={k} sm="6">
          <div className="form-group">
            <label htmlFor={k}>{label}</label>
            <Input
              type={type}
              className="form-control"
              name={k}
              value={field_value}
              onChange={this.onChangeMetadata.bind(this, k)}
              validations={check}
              disabled={!this.isLotEditable() || disabled_field}
            />
          </div>
        </Col>
      )
    });

    return (
      <div className="row">
        {listMetadata}
      </div>
    );
    
  }

  renderStatusSelector(){
    const listStatus = this.props.status_array.map((k) => {
      let label = k.label;
      let show_edit = k.show_edit;
      
      if(show_edit || this.state.lot.status == 'SOLD'){
        return (
          <option key={k.key} value={k.key}>{label}</option>
        );
      }
    });

    return (
      <Select className="form-control" name='status' value={this.state.lot.status} onChange={this.onChangeStatus} validations={[required]} disabled={this.state.lot.status == 'SOLD' || !this.isLotEditable()} >
          <option value=''>Seleccionar...</option>
          {listStatus}
      </Select>
    );
    
  }

  onChangeName = (e) => {
    this.setState({
      lot: {...this.state.lot, ...{name: e.target.value}}
    });
  }

  onChangeBlock = (e) => {
    this.setState({
      lot: {...this.state.lot, ...{block: e.target.value ? parseInt(e.target.value) : e.target.value}}
    });
  }

  onChangeNumber = (e) => {
    this.setState({
      lot: {...this.state.lot, ...{number: e.target.value ? parseInt(e.target.value) : e.target.value}}
    });
  }

  onChangeHeight = (e) => {
    this.setState({
      lot: {...this.state.lot, ...{height: e.target.value ? parseFloat(e.target.value) : e.target.value}}
    });
  }

  onChangeStatus = (e) => {
    this.setState({
      lot: {...this.state.lot, ...{status: e.target.value}}
    });
  }

  onChangePrice = (e) => {
    this.setState({
      lot: {...this.state.lot, ...{price: e.target.value}}
    });
  }

  onChangeDiscount = (e) => {
    this.setState({
      lot: {...this.state.lot, ...{discount: e.target.value}}
    });
  }

  onChangeCoord = (i, j, e) => {
    this.state.invalid_coords = false;
    let coords = [...this.state.coords]
    coords[i][j] = e.target.value;
    this.setState({
      coords: coords
    });
  }

  onChangeMetadata = (k, e) => {
    if(k != 'LOT_PRICE'){
      let meta = {...this.state.lot_metadata};
      meta[k] = e.target.value;
      this.setState({
        lot_metadata: meta
      });
    }
  }

  /*renderReserveBtn = () => {
    if(this.props.action == 'update' && this.state.lot.status != 'SOLD'){
      return (
        <button className="btn btn-success btn-add-lot" onClick={this.props.reserve.bind(this, this.state.lot)}>Reservar</button>
      );
    }else if(this.props.action == 'update' && this.state.lot.status == 'SOLD'){
      return (
        <button className="btn btn-success btn-add-lot" onClick={this.props.view_reservation.bind(this, this.state.lot)}>Ver Reservación</button>
      );
    }
  }*/

  renderSaveBtn = () => {
    if( (this.props.action == 'add' && methods.G_canDo(consts.Security.Action.CREATE_LOT, localStorage.getItem('user'))) ||
      (this.props.action == 'update' && this.state.lot.status != 'SOLD' && methods.G_canDo(consts.Security.Action.UPDATE_LOT, localStorage.getItem('user'))) ||
      (this.props.action == 'update' && this.state.lot.status == 'SOLD' && methods.G_canDo(consts.Security.Action.EDIT_RESERVED_LOT, localStorage.getItem('user')))
    ){
      return (
        <button
          className="btn btn-cust-blue mr-3"
          disabled={this.state.loading}
        >
          {this.state.loading && (
            <span className="spinner-border spinner-border-sm"></span>
          )}
          <span>{this.getSaveBtnLabel()}</span>
        </button>
      )
    }
  }

  delete = (e) => {
    e.preventDefault();
    const lot = this.state.lot;
    if(window.confirm('¿Estás seguro que deseas eliminar el lote ' + lot.name + '?') == true){
      let id = lot['_id'];
      if(id){
        deleteLot(id).then(
          (res) => {
            if(res && res['_id']){
              this.props.update_deleted(res['_id']);
            }else{
              // TODO: Mostrar mensaje
            }
          }
        );
      }
    }
  }

  renderDeleteBtn = () => {
    if(this.props.action == 'update' && methods.G_canDo(consts.Security.Action.DELETE_LOT, localStorage.getItem('user'))){
      return (
        <button className="btn btn-cust-orange float-left delete-lot" onClick={this.delete.bind(this)}>Eliminar</button>
      );
    }
  }

  renderTowerSelector(){
    const list = this.props.vertical.towers.map((k) => {
      let label = k.name;
      
      return (
        <option key={k._id} value={k._id}>{label}</option>
      );
      
    });

    return (
      <Select className="form-control" name='tower' value={this.state.lot.tower_id} onChange={this.onChangeTower} validations={[required]} disabled={!this.isLotEditable()} >
          <option value=''>Seleccionar...</option>
          {list}
      </Select>
    );
    
  }

  onChangeTower = (e) => {
    const sel_id = e.target.value;
    let selected = this.props.vertical.towers.find(x => x._id == sel_id);
    const sel_number = selected && selected._id ? selected.order : 0;
    this.setState({
      lot: {...this.state.lot, ...{tower_id: sel_id, tower_number: sel_number}}
    });
  }

  renderStorySelector(){
    let tower_id = this.state.lot.tower_id;
    let tower_stories = this.props.vertical.stories.filter(x => x.tower_id == tower_id);
    
    const list = tower_stories.map((k) => {
      let label = k.number;
      
      return (
        <option key={k._id} value={k._id}>{label}</option>
      );
      
    });

    return (
      <Select className="form-control" name='tower' value={this.state.lot.story_id} onChange={this.onChangeStory} validations={[required]} disabled={!this.isLotEditable()} >
          <option value=''>Seleccionar...</option>
          {list}
      </Select>
    );
    
  }

  onChangeStory = (e) => {
    const sel_id = e.target.value;
    let selected = this.props.vertical.stories.find(x => x._id == sel_id);
    const sel_number = selected && selected._id ? selected.number : 0;
    this.setState({
      lot: {...this.state.lot, ...{story_id: sel_id, story_number: sel_number}}
    });
  }

  render() {
    return (
      <div className="containter">
        {this.renderTitle()}
        
        <Form
          onSubmit={this.handleSubmit}
          ref={c => {
            this.form = c;
          }}
        >
          <h5>Coordenadas {this.renderCoordsTypeTitle()}</h5>
          <span><b>Nota:</b> Ingresa las coordenadas en sentido horario desde el P1.</span><br/><br/>
          <div className="form-group row">
            <Col xs="1"></Col>
            <Col xs="4" className="labels">{this.renderCoordinateTitle(0)}</Col>
            <Col xs="4" className="labels">{this.renderCoordinateTitle(1)}</Col>
          </div>
          {this.renderCoordinatesInputs()}
          <hr/>
          <h5>Información</h5>
          <div className="row">
            <Col sm="4">
              <div className="form-group">
                <label htmlFor="name">Nombre</label>
                <Input
                  type="text"
                  className="form-control"
                  name="name"
                  value={this.state.lot.name}
                  onChange={this.onChangeName}
                  validations={[required]}
                  disabled={!this.isLotEditable()}
                />
              </div>
            </Col>
            <Col sm="4">
              <div className="form-group">
                <label htmlFor="block">Manzana</label>
                <Input
                  type="number"
                  className="form-control"
                  name="block"
                  value={this.state.lot.block}
                  onChange={this.onChangeBlock}
                  validations={[required,positiveNumber]}
                  disabled={!this.isLotEditable()}
                />
              </div>
            </Col>
            { this.props.development &&
              this.props.development.is_vertical &&
              this.props.vertical &&
              this.props.vertical.towers &&
              <Col sm="4">
                <div className="form-group">
                  <label htmlFor="block">Edificio</label>
                  {this.renderTowerSelector()}
                </div>
              </Col>
            }
            { this.props.development &&
              this.props.development.is_vertical &&
              this.props.vertical &&
              this.props.vertical.stories &&
              <Col sm="4">
                <div className="form-group">
                  <label htmlFor="block">Piso</label>
                  {this.renderStorySelector()}
                </div>
              </Col>
            }
            <Col sm="4">
              <div className="form-group">
                <label htmlFor="number">Número</label>
                <Input
                  type="number"
                  className="form-control"
                  name="number"
                  value={this.state.lot.number}
                  onChange={this.onChangeNumber}
                  validations={[required,positiveNumber]}
                  disabled={!this.isLotEditable()}
                />
              </div>
            </Col>
            <Col sm="6">
              <div className="form-group">
                <label htmlFor="height">Altura (m)</label>
                <Input
                  type="number"
                  className="form-control"
                  name="height"
                  value={this.state.lot.height}
                  onChange={this.onChangeHeight}
                  validations={[required,positiveNumber]}
                  disabled={!this.isLotEditable()}
                />
              </div>
            </Col>
            <Col sm="6">
              <div className="form-group">
                <label htmlFor="status">Estatus</label>
                {this.renderStatusSelector()}
              </div>
            </Col>
            <Col sm="6">
              <div className="form-group">
                <label htmlFor="price">Reserva con (MXN)</label>
                <Input
                  type="number"
                  className="form-control"
                  name="price"
                  value={this.state.lot.price}
                  onChange={this.onChangePrice}
                  validations={[positiveNumber]}
                  disabled={!this.isLotEditable()}
                />
              </div>
            </Col>
            <Col sm="6">
              <div className="form-group">
                <label htmlFor="discount">Descuento (MXN)</label>
                <Input
                  type="number"
                  className="form-control"
                  name="discount"
                  value={this.state.lot.discount}
                  onChange={this.onChangeDiscount}
                  validations={[positiveNumber]}
                  disabled={!this.isLotEditable()}
                />
              </div>
            </Col>
          </div>

          <hr/>
          <h5>Detalles</h5>
          {this.renderMetadataInputs()}

          <div className="form-group text-right">

            {this.renderDeleteBtn()}

            {this.renderSaveBtn()}
          
            <button className="btn btn-cust-red" onClick={this.props.close}>Cancelar</button>
            
          </div>

          {this.state.message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {this.state.message}
              </div>
            </div>
          )}
          <CheckButton
            style={{ display: "none" }}
            ref={c => {
              this.checkBtn = c;
            }}
          />
        </Form>
      </div>
    );
  }

}

export default withRouter(LotForm);
